import cx from './cx';
import { ICONS } from './icons';

// Canonical icon component. Decorative by default (aria-hidden);
// pass `label` to expose it to assistive tech.
export default function Icon({ name, size = 16, label, className }) {
  const shapes = ICONS[name] || [];
  return (
    <svg
      className={cx('icon', className)}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      focusable="false"
    >
      {shapes.map((s, i) => {
        if (s.t === 'circle') return <circle key={i} cx={s.cx} cy={s.cy} r={s.r} />;
        if (s.t === 'rect') return <rect key={i} x={s.x} y={s.y} width={s.w} height={s.h} rx={s.rx} />;
        return <path key={i} d={s.d} />;
      })}
    </svg>
  );
}
